import { render, staticRenderFns } from "./ChatSetAdminButton.vue?vue&type=template&id=2ada548b&"
import script from "./ChatSetAdminButton.vue?vue&type=script&lang=js&"
export * from "./ChatSetAdminButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports